<template>
	<div class="create-chat">
		<template v-if="isWaiting">
			<Loader/>
		</template>
		<template v-else>
			<h2>Opret chat/samtale</h2>
			<input class="mb20" type="text" v-model="roomName" placeholder="Giv din chat et navn" />
            <h3>Del din nøgle</h3>
            <div class="alias" v-clipboard="workingRoom.alias" v-clipboard:success="clipboardSuccessHandler" v-clipboard:error="clipboardErrorHandler">
                {{workingRoom.alias}}
                <transition name="fade">
                    <Bubble v-if="showBubbleIsCopied" type="bottom">Nøglen er nu kopieret</Bubble>
                </transition>
            </div>
            <p class="small">For at invitere dine venner ind skal du dele ovenstående nøgle med dem.</p>
            <br/>
			<button @click="finalizeCreation">OK</button>
		</template>
	</div>
</template>

<script>
	import Loader from "@/components/Loader";
	import Bubble from "@/components/Bubble";
	export default {
		components: {Loader,Bubble},
		data(){
			return {
				isWaiting: true,
				finishedCreation: false,
				workingRoom: {},
				roomName: '',
                showBubbleIsCopied: false
			}
		},
		methods: {
			clipboardSuccessHandler ({ value, event }) {
				let that = this
				this.showBubbleIsCopied = true
				setTimeout(function(){
					that.showBubbleIsCopied = false
				}, 2000)
			},
			clipboardErrorHandler ({ value, event }) {
				console.log('error', value)
			},
			finalizeCreation()
			{
				console.log('finalize');
				const that = this;
				const roomName = that.roomName.trim();
				if(roomName !== '')
				{
					console.log(roomName);
					this.$vorbasseSocket.listen('room-data-updated',(result) => {
						console.log('room-data-updated');
						that.$vorbasseSocket.stopListening('room-data-updated');
						that.isWaiting = false;
						that.finishedCreation = true;
						that.$emit('finishedCreation');
					});

					this.isWaiting = true;
					this.$vorbasseSocket.emit('update-room-meta',{
						room:that.workingRoom.room,
						name: roomName
					});
				}
				else
				{
					this.$store.dispatch('vorbasse/showPrompt',{
						title: 'Chat mangler info',
						prompt: 'Du har ikke givet din chat et navn!',
						confirmText: 'Ok - forstået',
						showCancelButton: false
					});
				}

			},
			createRoom()
			{
				console.log('create room');
				const that = this;
				const key = this.$vorbasseSocket.onCommand('room-created',(result) => {
					that.workingRoom = result.data;
					that.isWaiting = false;
					console.log('created room');
					that.$vorbasseSocket.dropCommandListener('room-created',key);
				});

				this.isWaiting = true;
				this.$vorbasseSocket.emit('create-room',{
					type:'chat',
					returnRoom: true
				});
			}
		},
		beforeDestroy()
		{
			if(this.finishedCreation === false)
				this.$vorbasseSocket.emit('leave-room',this.workingRoom.room);
		},
		mounted()
		{
			this.createRoom()
		}
	};
</script>
